import { render, staticRenderFns } from "./DocumentPanel.vue?vue&type=template&id=21db90d6"
import script from "./DocumentPanel.vue?vue&type=script&lang=js"
export * from "./DocumentPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports